export default __webpack_public_path__ + "static/media/GoogleSans-SemiBold.05df0396.ttf";